module.exports = __webpack_public_path__ + "static/img/service1.b3faff6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service1.jpg
// module id = PwBN
// module chunks = 21